module.exports = __webpack_public_path__ + "static/img/base_5.c1b8da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/base_5.jpg
// module id = BrsQ
// module chunks = 1